import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { TableActionItems } from '../datatable/TableActionItems';
import '../../style/DataTable.css';
import { formatBackendDateEtLocale } from '../../util/dateUtil';

const SeasonsDataTable = (props) => {
  const getSeasonsData = () => {
    let rowData = [];
    const leagueNameReducer = (accumulator, currentValue) =>
      accumulator + ', ' + currentValue;

    props.seasons.map((row) =>
      rowData.push({
        name: row.name ? row.name : 'N/A',
        startDate: row.startDate
          ? formatBackendDateEtLocale(row.startDate)
          : 'N/A',
        endDate: row.endDate ? formatBackendDateEtLocale(row.endDate) : 'N/A',
        leagueNames:
          row.leagues && row.leagues.length !== 0
            ? row.leagues.map((league) => league.name).reduce(leagueNameReducer)
            : 'N/A',
        actions: (
          <TableActionItems editAction={() => props.editAction(row.id)} />
        ),
      })
    );
    if (!rowData.length) {
      return null;
    }

    return {
      columns: [
        {
          label: 'Nimi',
          field: 'name',
        },
        {
          label: 'Algus',
          field: 'startDate',
        },
        {
          label: 'Lõpp',
          field: 'endDate',
        },
        {
          label: 'Liiga(d)',
          field: 'leagueNames',
        },
        {
          label: '',
          field: 'actions',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getSeasonsData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default SeasonsDataTable;
